import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { Message } from '@paypalcorp/worldready-react';
import { BodyText, Button, HeadingText, Link } from '@paypalcorp/pp-react';
import { CONTACT_TOPIC_TREE_INTENTS } from '../../common/storeConstants';
import { getArticleLink } from '../../helpers/twHelper';
import { ocpPromptChangeSelected } from './TopicIntents-Actions';
import { ocpPromptFPTIs } from '../../helpers/analytics/contactUsPageAnalytics';
import { generateLinkData, trackActivityEvent, trackClickEvent } from '../../helpers/analytics/fptiHelper';

import ContactOptionIcon from '../ContactOption/ContactOptionIcon';
import TopicIntentIcons from './TopicIntentIcon';

const OcpPromptSelectionBar = function () {
  const dispatch = useDispatch();
  const { isLoading, isError, selectedOcpPrompt } = useSelector((state) => state[CONTACT_TOPIC_TREE_INTENTS]);

  const targetBlank = '_blank';
  const ocpPromptIntent = _get(selectedOcpPrompt, 'channelDetails.intentCode', '');
  const ocpPromptName = _get(selectedOcpPrompt, 'channelDetails.intentName', '');
  const ocpArticleTitle = selectedOcpPrompt && selectedOcpPrompt.articleTitle;
  const ocpArticleId = selectedOcpPrompt && selectedOcpPrompt.articleId;

  // Fpti - OCP prompt change button clicked
  const ocpChangeBtnClickedFpti = () => {
    const fptiData = {
      ...ocpPromptFPTIs.ocpPromptChangeRequested,
      ...{
        link: generateLinkData(ocpPromptFPTIs.ocpPromptChangeRequested.link, { ocpIntent: ocpPromptIntent }),
      },
    };
    trackClickEvent(fptiData);
  };

  /**
   * Function to fire 2 FPTIs:-
   *  1) OCP prompt change button shown
   *  2) OCP Article Link shown
   * */
  const ocpArticleShownFptis = () => {
    // Fire OCP Article link shown FPTI
    const articleLinkShownFptiData = {
      ...ocpPromptFPTIs.ocpPromptArticleLinkShown,
      ...{ hpid: ocpArticleId },
    };
    trackActivityEvent(articleLinkShownFptiData);
    // Fire OCP Prompt change button shown FPTI
    trackActivityEvent(ocpPromptFPTIs.ocpPromptChangeBtnShown);
  };

  const handleChangeOcpClick = (e) => {
    e.preventDefault();
    ocpChangeBtnClickedFpti();
    dispatch(ocpPromptChangeSelected());
  };

  const handleOcpArticleClick = (e) => {
    e.preventDefault();
    // Fire OCP Article link clicked FPTI
    const fptiData = {
      ...ocpPromptFPTIs.ocpPromptArticleLinkClicked,
      ...{
        link: generateLinkData(ocpPromptFPTIs.ocpPromptArticleLinkClicked.link, { articleId: ocpArticleId }),
        hpid: ocpArticleId,
      },
    };
    trackClickEvent(fptiData);
    // handle the OCP Article link click
    return window.open(getArticleLink(ocpArticleId, ocpArticleTitle), targetBlank);
  };

  const renderOcpPrompt = () => {
    // Fire OCP prompt change button shown and OCP Article Link shown FPTIs
    ocpArticleShownFptis();

    // Render the OCP prompt and Article link
    return (
      <div className="sh_ocp_prompt_sel_bar__main" data-testid="sh-ocp-prompt-final-selection-container">
        <div className="sh_ocp_prompt__final_selection" data-testid="sh-ocp-prompt-final-selection">
          <div>
            <TopicIntentIcons
              refId={selectedOcpPrompt?.channelDetails?.intentCode}
              size="md"
              className="sh_ocp_prompt_contact_options__icon"
              dataTestId="sh-ocp-prompt-final-selection-heading-icon"
            />
            <HeadingText
              size="sm"
              className="sh_ocp_prompt__final_selection__heading_text"
              data-testid="sh-ocp-prompt-final-selection-heading-text"
            >
              {ocpPromptName}
            </HeadingText>
          </div>
          <Button
            size="sm"
            secondary
            onClick={(e) => handleChangeOcpClick(e)}
            className="sh_ocp_prompt_change__button"
            data-testid="sh-ocp-prompt-change-ocp-btn"
          >
            <Message id="smarthelp.app.topic.finalselection.button.label" />
          </Button>
        </div>
        <hr />
        <div className="sh_ocp_prompt_contact_options" data-testid="sh-ocp-prompt-contact-options-container">
          <BodyText
            className="sh_ocp_prompt_contact_options__header"
            data-testid="sh-ocp-prompt-contact-options-header"
          >
            <Message id="smarthelp.app.contactOption.article.header" />
          </BodyText>
          <div className="sh_ocp_prompt_contact_options__text" data-testid="sh-ocp-prompt-article-link-container">
            <ContactOptionIcon
              size="md"
              type="article"
              className="sh_ocp_prompt_contact_options__icon"
              data-testid="sh-ocp-prompt-article-link-icon"
            />
            <Link
              size="lg"
              href={getArticleLink(ocpArticleId, ocpArticleTitle)}
              className="sh_ocp_prompt_contact_options__text_content"
              data-testid="sh-ocp-prompt-article-link"
              onClick={(e) => handleOcpArticleClick(e)}
            >
              {ocpArticleTitle}
            </Link>
          </div>
        </div>
      </div>
    );
  };

  if (!isLoading && !isError && !_isEmpty(selectedOcpPrompt)) {
    return renderOcpPrompt();
  }

  return null;
};

export default OcpPromptSelectionBar;
